import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { AgentType, ResidualsSplitProfileType } from "types";

import { StraightSplitPrimarySplitInformation } from "./straightSplitPrimarySplitInformation";

type StraightSplitProps = {
	isLoading: boolean;
	splitProfile: ResidualsSplitProfileType;
	isEditing: boolean;
	currentAgent?: AgentType;
};

export const StraightSplit = ({
	isLoading,
	splitProfile,
	isEditing,
	currentAgent,
}: StraightSplitProps) => {
	const { setValue, watch, control } = useFormContext();
	const { fields, append, remove } = useFieldArray({
		control,
		name: "secondarySplitInformation",
		keyName: "ide",
	});
	// remove secondarySplitInformation in case with change scenario to StraightSplit (edit form)
	useEffect(() => {
		if (fields.length > 0) {
			remove();
		}
	}, [fields, append, remove]);

	const totalRevenueShare = watch("totalRevenueShare");

	useEffect(() => {
		setValue("primarySplitInformation.splitPercent", totalRevenueShare);
	}, [totalRevenueShare, setValue]);

	return (
		<StraightSplitPrimarySplitInformation
			name="primarySplitInformation"
			title="Primary Split Information"
			splitInfo={splitProfile?.primarySplitInformation}
			currentAgent={currentAgent}
			isLoading={isLoading}
			isEditing={isEditing}
		/>
	);
};
